import axios from "axios";
class NcicServices {

    sendNcicRequest = async (payload) => {
        if (payload) {
            return await axios.post(
                `/NCICDetails/SendNcicRequest`,
                payload
            );
        }
        console.warn("payload not provided, NcicServices.sendNcicRequest");
        return null;
    };

    getNCICParsedResponse = async (payload) => {
        if (payload) {
            return await axios.post(
                `/NCICDetails/GetNCICParsedResponse`,
                payload
            );
        }
        console.warn("payload not provided, NcicServices.getNCICParsedResponse");
        return null;
    };

    getNCICParsedResponseSummary = async (payload) => {
        if (payload) {
            return await axios.post(
                `/NCICDetails/GetNCICParsedResponse`,
                payload
            );
        }
        console.warn("payload not provided, NcicServices.getNCICParsedResponseSummary");
        return null;
    };

    getNCICResponse = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(
                `/NCICDetails/GetNCICResponse`,
                payload
            );
        }
        console.warn("payload not provided, NcicServices.getNCICResponse");
        return null;
    };

    attachNCICToIncident = async (payload) => {
        if (payload) {
            return await axios.post(
                `/NCICDetails/AttachNCICToIncident`,
                payload
            );
        }
        console.warn("payload not provided, NcicServices.attachNCICToIncident");
        return null;
    };

    getAllResponseOfNCICByIncidentID = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(
                `/NCICDetails/Get_All_ResponseOfNCIC_By_IncidenID`,
                payload
            );
        }
        console.warn("payload not provided, NcicServices.getAllResponseOfNCICByIncidentID");
        return null;
    };

}

const instance = new NcicServices();

export default instance;
